const POPULAR_MAKES_UK = ['audi', 'seat', 'skoda', 'volkswagen', 'cupra'];
export { POPULAR_MAKES_UK };
